import React from 'react';

import { MarcasContainer, MarcaImage } from './MarcasStyles';

// Swiper config
import { Pagination } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/scss';
import 'swiper/scss/pagination';

function MarcasSlider({ marcas }) {
  return (
    <MarcasContainer>
      <Swiper
        modules={[ Pagination ]}
        spaceBetween={5}
        pagination={{ clickable: true }}
        breakpoints={{
          320: {
            slidesPerView: 3,
          },
          480: {
            // width: 768,
            slidesPerView: 7,
          },
        }}
      >
        
        {
          marcas.map((marca) => (
            <SwiperSlide>
              <MarcaImage src={marca.logo} alt={marca.title} />
            </SwiperSlide>
          ))
        }
      </Swiper>
    </MarcasContainer>
  )
}

export default MarcasSlider